import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddHighLightLayer from "../components/AddPromotionLayer";
 
 
const AddHighlightPage = () => {
  return (
    <>
   
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Promotion  </h5><Breadcrumb title="Add Promotion" /></div>
 
        {/* CalendarMainLayer */}
        <AddHighLightLayer />
 
 
    </>
  );
};
 
export default AddHighlightPage;
 
 